// updating this values will also require to update regex
// in @/utils/validateCommentMessage
export const minCommentMessageLength = 1
export const maxCommentMessageLength = 1000
